'use strict'

/**
 * @module results
 * @requires components:filters
 * @requires components:searchmap
 * */
import filters from '../components/filters'
import searchmap from '../components/searchmap'

export default {
  /* *
   * Initialise results
   *
   * @method init
   * */
  init() {
    /**
     * @see module:filters#init
     */
    filters.init()
    searchmap.init()
  }
}



// WEBPACK FOOTER //
// ./src/apps/Front/private/js/modules/results.js